import React, { Component } from "react";
import PropTypes from 'prop-types';
import ServicesComponent from './components/ServicesComponent';
import "./../Home/assets/css/fontawesome.css";
import "./../Home/assets/css/templatemo-finance-business.css";
import "./../Home/assets/css/owl.css";


export class ServicesContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the Services page
            service:'tab-1',
        }
        this.updateService = this.updateService.bind(this);
    }

    updateService(selected){
        this.setState({service:selected});
    }

    render(){
        return(
            <ServicesComponent 
                service={this.state.service} updateService={this.updateService}
                tab={this.props.tab} updateTab={this.props.updateTab}
            />
        )
    }
          
        
}

ServicesContainer.defaultProps={

}
ServicesContainer.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,
}

export default(ServicesContainer);